import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { MessagesStore } from '../stores';
import { IMessage } from '../../../interfaces/IMessage';
import { ILike } from '../../../interfaces/ILike';
import { IAMessagesListView } from '../../messagesListView/MessagesListView';
import { Helper } from '../../../Helper';
import DateTimeService from '../../../services/DateTimeService';

export interface IListViewProps {
  messagesStore?: MessagesStore;
}

@inject('messagesStore')
@observer
export default class ListView extends React.Component<IListViewProps> {
  private dateTimeService = new DateTimeService();

  constructor(props, state) {
    super(props, state);
  }

  private skeletonList(): JSX.Element[] {
    let skeletonListItems = [];
    let numMessages = this.props.messagesStore.numMessages > 20 ? 20 : this.props.messagesStore.numMessages;
    for (let i = 0; i < numMessages; i++) {
      skeletonListItems.push(
        <div key={`skeletonListItem_${i}`} >
          <IAMessagesListView
            showSkeleton={true}
            width={this.props.messagesStore.width - 2}
            backgroundColor="#fff"
            borderRadius={this.props.messagesStore.borderRadius}
            showImage={this.props.messagesStore.showImage}
            showTitle={this.props.messagesStore.showTitle}
            showCategories={this.props.messagesStore.showCategories}
            showTeaser={this.props.messagesStore.showTeaser}
            showAuthor={this.props.messagesStore.showAuthor}
            showStartDate={this.props.messagesStore.showStartDate}
            showLikes={this.props.messagesStore.showLikes}
            showComments={this.props.messagesStore.showComments}
            showDropShadow={this.props.messagesStore.showDropShadow}
            showUniqueViews={this.props.messagesStore.showUniqueViews}
            isMobile={this.props.messagesStore.isMobile}
            hasDarkBackground={this.props.messagesStore.hasDarkBackground}
            image={""}
            isPanelOpen={this.props.messagesStore.panelIsOpen}
          />
        </div>
      );
    }
    return skeletonListItems;
  }

  public render(): JSX.Element {
    let messagesToDisplay = [];
    let itemsToShow: IMessage[] = [];
    if (this.props.messagesStore.messages) {
      if (this.props.messagesStore.isMobile) {
        itemsToShow = this.props.messagesStore.messages;
      } else {
        const startIndex = (this.props.messagesStore.pageNumber - 1) * this.props.messagesStore.numMessages;
        const endIndex = this.props.messagesStore.pageNumber * this.props.messagesStore.numMessages;
        itemsToShow = this.props.messagesStore.messages.slice(startIndex, endIndex)
      }
      itemsToShow.forEach((message: IMessage) => {
        let content = message.content;
        if (!content) {
          content = "";
        }
        let div = document.createElement("div");
        div.innerHTML = content.replace(/<\/p>/g, "</p> ").replace(/<\/h1>/g, "</h1> ").replace(/<\/h2>/g, "</h2> ").replace(/<\/li>/g, "</li> ");
        let contentText = (this.props.messagesStore.instance?.settings?.enableTeaser || localStorage.getItem("enableTeaser")) && message.teaser ? message.teaser : div.textContent || div.innerText || "";
        let author = message.author;
        if (message.contacts != undefined && message.contacts.length > 0) {
          author = message.contacts[0];
        }
        let videoUrl = message?.videoUrl;
        if ((location.href.includes("sharepoint.com") && message?.videoEmbedCode) || (videoUrl == undefined && message?.videoEmbedCode)) {
          videoUrl = Helper.getVideoSrcFromEmbedCode(message.videoEmbedCode);
        }
        messagesToDisplay.push(
          <div key={message.id.toString()} >
            <IAMessagesListView
              key={message.id.toString()}
              id={message.id.toString()}
              tenant={this.props.messagesStore.tenant}
              component="Message"
              source="SharePoint"
              instance={this.props.messagesStore.instance.instanceName}
              token={this.props.messagesStore.token}
              environment={this.props.messagesStore.environment}
              user={this.props.messagesStore.user}
              author={author}
              likesEnabled={this.props.messagesStore.likesEnabled}
              commentsEnabled={this.props.messagesStore.commentsEnabled}
              modifiedDate={message.startDate}
              title={message.title}
              teaser={contentText}
              item={message}
              videoUrl={videoUrl}
              image={message.image}
              iaMessageBgImagesFromBlob={message.iaMessageBgImagesFromBlob}
              iaConfiguration={message.iaConfiguration}
              itemTitleColor={this.props.messagesStore.headLineColor}
              itemTextColor={this.props.messagesStore.textColor}
              categories={message.categories ? message.categories : []}
              showCommandBarItems={this.props.messagesStore.showCommandBarItems && this.props.messagesStore.userRole == "Administrator" || this.props.messagesStore.showCommandBarItems && this.props.messagesStore.userRole == "Editor" && message.author != undefined && this.props.messagesStore.user != undefined && message.author.email?.toLowerCase() == this.props.messagesStore.user.email?.toLowerCase()}
              showSkeleton={false}
              borderRadius={this.props.messagesStore.borderRadius}
              width={this.props.messagesStore.width - 2}
              highlightColor={this.props.messagesStore.rollupHighlightColor}
              fontSlots={this.props.messagesStore.fontSlots}
              userLocation={this.props.messagesStore.userLocation}
              likes={message.likes}
              showEmojiPickerExpandButton={this.props.messagesStore.instance?.settings?.showEmojiPickerExpandButton}
              reactionOptions={this.props.messagesStore.instance?.settings?.reactionOptions}
              commentCount={message.commentCount}
              onClickEdit={(messageToEdit: IMessage) => {
                if (this.props.messagesStore.instance && messageToEdit?.iaConfiguration?.composerComponents) {
                  this.props.messagesStore.editMessage(messageToEdit);
                } else {
                  this.props.messagesStore.showConvertToComposerPopup = messageToEdit;
                }
              }}
              onClickDelete={(messageToDelete: IMessage) => this.props.messagesStore.messageToDelete = messageToDelete}
              onClickOpen={(messageToOpen: IMessage) => this.props.messagesStore.openMessage(messageToOpen)}
              backgroundColor={this.props.messagesStore.backgroundColor != undefined ? this.props.messagesStore.backgroundColor : undefined}
              borderColor={this.props.messagesStore.borderColor != undefined ? this.props.messagesStore.borderColor : undefined}
              likesUpdated={(message: IMessage, likes: ILike[]) => {
                message.likes = likes;
              }}
              commentsUpdated={(message: IMessage, comments: number) => {
                message.commentCount = comments;
              }}
              commentsClick={() => { this.props.messagesStore.commentsClick(message); }}
              showImage={this.props.messagesStore.showImage}
              showTitle={this.props.messagesStore.showTitle}
              showCategories={this.props.messagesStore.showCategories}
              showTeaser={this.props.messagesStore.showTeaser}
              showAuthor={this.props.messagesStore.showAuthor}
              showStartDate={this.props.messagesStore.showStartDate}
              showLikes={this.props.messagesStore.showLikes && !message.iaConfiguration?.disableLikes}
              showComments={this.props.messagesStore.showComments && !message.iaConfiguration?.disableComments}
              showDropShadow={this.props.messagesStore.showDropShadow}
              showUniqueViews={this.props.messagesStore.showUniqueViews}
              uniqueViewsCount={message.uniqueViews}
              isMobile={this.props.messagesStore.isMobile}
              isUnread={!message.isRead && this.props.messagesStore.instance?.settings?.enableReadUnreadMessage}
              unReadHighlight={this.props.messagesStore.instance?.settings?.highlightUnread}
              isPanelOpen={this.props.messagesStore.panelIsOpen}
              showPinIcon={message.isPinned && (new Date(message.pinnedEndDate) > new Date())}
              showLikesDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showLikes && !message.iaConfiguration?.disableLikes}
              showCommentsDimmed={this.props.messagesStore.loadingCommentsAndLikes && this.props.messagesStore.showComments && !message.iaConfiguration?.isNewsLink && !message.iaConfiguration?.disableComments}
              showUniqueViewsDimmed={this.props.messagesStore.loadingUniqueViews && this.props.messagesStore.showUniqueViews && this.dateTimeService.isOlderThanOneHour(message.startDate)}
            />
          </div>
        );
      });
    }
    let showSkeleton = this.props.messagesStore.loading;
    if (this.props.messagesStore.loading && this.props.messagesStore.isMobile && this.props.messagesStore.messages && this.props.messagesStore.messages.length > 0) {
      showSkeleton = false;
    }
    return this.props.messagesStore.width != undefined ? (
      <div
        style={{
          width: "calc(100% - 2px)",
          overflow: "hidden",
          height: "auto",
          padding: "0px 1px"
        }}
      >
        {showSkeleton ?
          this.skeletonList()
          :
          messagesToDisplay
        }
      </div>
    )
      :
      (
        <div
          style={{
            width: "calc(100% - 2px)",
            overflow: "hidden",
            height: "auto",
            padding: "0px 1px"
          }}
        ></div>
      );
  }


}